import { browser } from '$app/environment';

import { getContext } from 'svelte';

import { ContextStateSymbol } from '@unleash/proxy-client-svelte';
import { get, type Writable, writable } from 'svelte/store';

import type { ProxyClientContext } from '../types';

export function useFlag(name: string, initialValue: boolean = false): Writable<boolean> {
  if (!browser) {
    return writable(initialValue);
  }
  const { isEnabled, client } = getContext<ProxyClientContext>(ContextStateSymbol);
  const currentClient = get(client);

  const flag = writable(initialValue || Boolean(isEnabled(name)));

  const updateFlagValue = () => {
    const enabled = Boolean(isEnabled(name));
    if (enabled !== get(flag)) {
      flag.set(enabled);
    }
  };

  currentClient?.on('update', updateFlagValue);
  currentClient?.on('ready', updateFlagValue);

  return flag;
}
